export enum UserRoleEnum {
    MANAGER = "MANAGER",
    CONSULTANT = "CONSULTANT",
    TOWER = "TOWER",
    PARTNERSHIP = "PARTNERSHIP",
  }